import { createContext } from "@lit/context";
var quoteContext = createContext("quote");
export { quoteContext };